<section class="video-dialog">
  <!-- close button -->
  <span class="video-dialog__close" (click)="close()">
    <i class="iconsax video-dialog__close-icon" icon-name="x"></i>
  </span>
  <!-- video -->
  <video controls autoplay>
    <source [src]="url" />
  </video>
</section>
